import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Avatar from 'react-avatar';
import { PacmanLoader } from 'react-spinners';
import { getUser as getCachedUser, logoutLocalStorage } from '../../../Auth/Signin/Signin';
import useAuthCache from '../../../hooks/useAuthCache';
import ActionsMenu from '../../../components/MenuItem';

export default function AuthCorner() {
  const history = useHistory();
  const { isLoading: auth0Loading, user: authCacheUser } = useAuthCache();
  const {
    isLoading,
    logout: auth0Logout,
    user: auth0User,
    isAuthenticated,
  } = useAuth0();

  const user = auth0User || authCacheUser || getCachedUser();
  const isStillLoading = isLoading || auth0Loading;
  const showUserMenu = Boolean(user) || (isAuthenticated && isStillLoading);

  const logout = () => {
    logoutLocalStorage();
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
  };

  if (showUserMenu) {
    return (
      <div className="fixed top-4 sm:top-6 right-4 sm:right-6 z-[60]">
        {isStillLoading && !user ? (
          <PacmanLoader color="#ffc356" size={7} aria-label="Loading Spinner" data-testid="loader" />
        ) : (
          <ActionsMenu
            anchorHorizontal="right"
            transformHorizontal="right"
            button={({ onClick }) => (
              <Avatar
                style={{ cursor: 'pointer' }}
                className="border border-border/60 shadow-2xl rounded-full"
                name={user?.name}
                size="42"
                round={true}
                src={user?.picture}
                onClick={onClick}
              />
            )}
          >
            <MenuItem disabled={true}>
              <Typography>{user?.name}</Typography>
            </MenuItem>
            <MenuItem disabled={true}>
              <Typography>{user?.email}</Typography>
            </MenuItem>
            <MenuItem onClick={logout}>
              <Typography>Fazer logout</Typography>
            </MenuItem>
          </ActionsMenu>
        )}
      </div>
    );
  }

  return (
    <div className="fixed top-4 sm:top-6 right-4 sm:right-6 z-[60]">
      <button
        type="button"
        onClick={() => history.push('/login')}
        className="text-[10px] sm:text-xs font-mono tracking-widest uppercase px-3 sm:px-4 py-2 sm:py-2.5 rounded-full bg-background/60 backdrop-blur-md border border-border/50 shadow-2xl hover:text-accent hover:border-accent transition-colors text-foreground"
      >
        Entrar
      </button>
    </div>
  );
}
